export interface ChillPortionsChartProps {
  chartView: 'dashboard' | 'graphs' | 'settings' | 'fullScreen';
  sectorId: string;
  farmId: string;
  hideLegend?: boolean;
  hideXValues?: boolean;
  hideYValues?: boolean;
  height?: number | string;
  title?: string;
  yAxisTitle?: string;
  refreshKey?: number;
}

/**
 * Configuración de la temporada de acumulación de porciones de frío.
 * A diferencia de Horas Frío, el modelo dinámico de Fishman/Erez no usa una
 * temperatura base (sólo necesita la temperatura horaria), por lo que la
 * configuración se limita al rango inicio/fin de temporada.
 */
export interface ChillPortionsConfigType {
  chillPortionsStartMonth: number;
  chillPortionsStartDay: number;
  chillPortionsEndMonth: number;
  chillPortionsEndDay: number;
}

export const DEFAULT_CHILL_PORTIONS_CONFIG: ChillPortionsConfigType = {
  chillPortionsStartMonth: 4,
  chillPortionsStartDay: 1,
  chillPortionsEndMonth: 9,
  chillPortionsEndDay: 30,
};
